import allGames from './all-games.svg'
import favourites from './favourites.svg'
import liveBlackjack from './live-blackjack.svg'
import casualGames from './casual-games.svg'
import liveRoulette from './live-roulette.svg'
import gameShow from './game-show.svg'
import liveDragonTiger from './live-dragon-tiger.svg'
import liveSicBo from './live-sic-bo.svg'
import liveDealer from './live-dealer.svg'
import videoSlots from './video-slots.svg'

export const CATEGORY_IMAGES = {
  all_games: allGames,
  all: allGames,
  favourites: favourites,
  favorite: favourites,
  live_blackjack: liveBlackjack,
  blackjack: liveBlackjack,
  casual_games: casualGames,
  casual: casualGames,
  live_roulette: liveRoulette,
  roulette: liveRoulette,
  game_show: gameShow,
  game_shows: gameShow,
  gameshow: gameShow,
  live_dragon_tiger: liveDragonTiger,
  dragon_tiger: liveDragonTiger,
  live_sic_bo: liveSicBo,
  sic_bo: liveSicBo,
  live_dealer: liveDealer,
  live: liveDealer,
  video_slots: videoSlots,
  slots: videoSlots,
  video_slot: videoSlots,
}

export const getCategoryImage = (key) => {
  if (!key) return allGames
  const normalized = key.toLowerCase().replace(/[-\s]+/g, '_')
  return CATEGORY_IMAGES[normalized] || allGames
}

export default CATEGORY_IMAGES
